import * as Yup from 'yup';

import { InputsTemplate } from '../../../inputs/InputsTemplate';
import { FormTemplate } from '../../FormTemplate';

import {
  initialValues,
  mock,
  validationSchemaDocName,
} from '../../../../../lib/mocks/change-doc-name-mock';

export const ChangeDocName = ({
  handleClose = () => {},
  handleSubmit = () => {},
  file = null,
  isEdit = false,
}) => {
  const handleSubmitForm = values => {
    if (handleSubmit) {
      handleSubmit({ file, values, handleClose, isEdit });
    }
  };

  return (
    <div className="relative flex flex-col gap-4 w-[260px] sm:w-[420px] exclude-click">
      <FormTemplate
        initialValues={initialValues}
        validationSchema={Yup.object(validationSchemaDocName)}
        handleSubmitForm={handleSubmitForm}
        buttonText={'Save'}
        bgColor={'bg-purpleColor border-purpleColor'}
      >
        {formProps => (
          <InputsTemplate
            formProps={formProps}
            inputsList={mock}
          />
        )}
      </FormTemplate>
    </div>
  );
};
